const FileIcons = {
  pdf: "https://pawareagoraagents.blob.core.windows.net/icons/pdf.png",
  generic: "https://pawareagoraagents.blob.core.windows.net/icons/file-type.png",
  image: "https://pawareagoraagents.blob.core.windows.net/icons/image-file.png",
  video: "https://pawareagoraagents.blob.core.windows.net/icons/video.png",
  audio: "https://pawareagoraagents.blob.core.windows.net/icons/audio.png",
  docx: "https://pawareagoraagents.blob.core.windows.net/icons/docx.png",
  csv: "https://pawareagoraagents.blob.core.windows.net/icons/csv.png",
  txt: "https://pawareagoraagents.blob.core.windows.net/icons/txt-file.png",
  xls: "https://pawareagoraagents.blob.core.windows.net/icons/xls.png"
};

// Função que faz um mapeamento mais completo
export const getFileIcon = (mimeType = "", filename = "") => {
  const ext = filename.split('.').pop()?.toLowerCase();

  if (mimeType === 'application/pdf' || ext === 'pdf') return FileIcons.pdf;

  if (mimeType.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'webp'].includes(ext))
    return FileIcons.image;

  if (mimeType.startsWith('video/') || ['mp4', 'webm', 'mov', 'avi', 'mkv'].includes(ext))
    return FileIcons.video;

  if (mimeType.startsWith('audio/') || ['mp3', 'wav', 'ogg', 'm4a'].includes(ext))
    return FileIcons.audio;

  if (
    ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(mimeType) ||
    ['docx', 'doc'].includes(ext)
  )
    return FileIcons.docx;

  if (
    ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(mimeType) ||
    ['xls', 'xlsx'].includes(ext)
  )
    return FileIcons.xls;

  if (mimeType === 'text/csv' || ext === 'csv') return FileIcons.csv;

  if (mimeType === 'text/plain' || ext === 'txt') return FileIcons.txt;

  return FileIcons.generic;
};

export default FileIcons;